import React, { type ReactNode } from 'react';

import ModalBody from '@atlaskit/modal-dialog/modal-body';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';

import { LoadingContent } from '../loading-content';

export const Loading = ({
	loadingText,
	title,
}: {
	loadingText?: ReactNode;
	title: ReactNode;
}): React.JSX.Element => (
	<>
		<ModalHeader hasCloseButton>{title ? <ModalTitle>{title}</ModalTitle> : null}</ModalHeader>
		<ModalBody>
			<LoadingContent loadingText={loadingText ?? 'Loading dialog content...'} size="large" />
		</ModalBody>
		<ModalFooter />
	</>
);
